import React from 'react';
import { PhoneMissed, Home } from 'lucide-react';

import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { resolvePostCallExitDestination } from '@/governor/routing/RouteAuthorityGovernor';

export default function CallEndedPage() {
  const navigate = useNavigate();


  const returnFromCall = async (): Promise<void> => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    const decision = resolvePostCallExitDestination(Boolean(session));

    try {
      const detail = Object.freeze({
        domain: 'routing',
        governor: 'ax-route-authority-governor',
        stage: 'POST_CALL_EXIT_AUTHORIZED',
        source: decision.source,
        requestedDestination: decision.requestedDestination,
        authorizedDestination: decision.authorizedDestination,
        authenticated: decision.authenticated,
        reason: decision.reason,
        timestamp: new Date().toISOString(),
      });

      localStorage.setItem(
        'kinscircle_post_call_route_evidence',
        JSON.stringify(detail),
      );

      window.dispatchEvent(
        new CustomEvent('kinscircle:governor-runtime-event', { detail }),
      );
    } catch {
      // Navigation must continue even if runtime evidence storage fails.
    }

    navigate(decision.authorizedDestination, { replace: true });
  };
  const p = new URLSearchParams(window.location.search);
  const name = p.get('name') || 'Family member';
  const mode = p.get('mode') || 'call';
  const status = p.get('status') || 'missed';

  return (
    <div className="min-h-screen bg-gradient-to-br from-fuchsia-50 to-white flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-3xl bg-white shadow-xl border border-fuchsia-100 p-8 text-center">
        <PhoneMissed className="mx-auto mb-4 text-fuchsia-600" size={48} />
        <h1 className="text-3xl font-bold text-slate-900">
          {status === 'missed' ? 'Missed call' : 'Call ended'}
        </h1>
        <p className="mt-3 text-slate-600">
          {mode === 'video' ? 'Video' : 'Voice'} call with {name}
        </p>
        <button
          type="button"
          onClick={() => { void returnFromCall(); }}
          className="mt-8 w-full rounded-2xl bg-fuchsia-600 text-white font-bold py-4 flex items-center justify-center gap-2"
        >
          <Home size={20} /> Return to KinsCircle
        </button>
      </div>
    </div>
  );
}
